module.exports = __webpack_public_path__ + "static/media/AssaAbloy.f3a5ee1c.png";